export const SUPPORT_EMAIL = "support@tardigradeteam.com";

export const QUESTIONS = [
  { key: "size", q: "How many people work within your organisation?", options: ["1", "2-8", "9-49", "50-249", "250+"] },
  { key: "cover", q: "If one or two key people were unexpectedly unavailable tomorrow, how well could others cover their responsibilities?", options: ["Easily", "Mostly", "With difficulty", "We are unsure"] },
  { key: "dependency", q: "How dependent is your organisation on suppliers, partners or external services?", options: ["Minimal dependency", "Some dependency", "Significant dependency", "Critical dependency"] },
  { key: "disruption", q: "Have you experienced a significant disruption in the last five years?", hint: "Examples may include staff shortages, supplier issues, technology failures, severe weather, financial pressures, pandemics or operational incidents.", options: ["Yes", "No", "Unsure"] },
  { key: "confidence", q: "If a major disruption occurred tomorrow, how confident are you that decisions would be made quickly and effectively?", options: ["Very confident", "Fairly confident", "Not very confident", "Unsure"] },
  { key: "collaboration", q: "How often do different teams or functions work together to solve unexpected problems?", options: ["Frequently", "Sometimes", "Rarely", "We are unsure"] },
  { key: "impact", q: "Who would feel the impact if your organisation was unable to operate for several days?", hint: "Select all that apply.", multi: true, options: ["Primarily ourselves", "Customers or clients", "Community groups", "Vulnerable people", "Essential public services"] },
  { key: "interest", q: "Would you be interested in exploring your organisation's resilience through a practical interactive exercise?", options: ["Yes", "Maybe", "Not currently"] },
];

export const OUTCOMES = {
  not_suitable: {
    title: "Not currently suitable",
    paragraphs: [
      "Based on your responses, a resilience simulation is unlikely to deliver significant value at this stage.",
      "Tardigrade simulations work best where teams, relationships and interdependencies can be explored collectively.",
      "The good news is that there are simple actions you can take today to improve resilience.",
    ],
    resources: [
      { title: "Business continuity starter checklist", file: "/resources/tardigradeteam-business-continuity-starter-checklist.pdf" },
      { title: "Supplier dependency worksheet", file: "/resources/tardigradeteam-supplier-dependency-worksheet.pdf" },
      { title: "Critical knowledge checklist", file: "/resources/tardigradeteam-critical-knowledge-checklist.pdf" },
      { title: "Incident response guide", file: "/resources/tardigradeteam-incident-response-guide.pdf" },
    ],
    closing: "We wish you every success on your resilience journey and invite you to reassess in the future as your organisation grows.",
  },
  good_candidate: {
    title: "Good candidate",
    paragraphs: [
      "Based on your responses, we believe a Tardigrade resilience simulation could provide meaningful value to your organisation.",
      "You've likely already developed resilience through experience, adaptation and teamwork.",
      "A simulation exercise can help uncover strengths, reveal hidden vulnerabilities and build confidence before disruption occurs.",
    ],
    cta: { label: "Book a Discovery Conversation", subject: "Discovery Conversation" },
  },
  complex: {
    title: "Complex organisation",
    paragraphs: [
      "Your organisation appears to operate across multiple teams, services or dependencies.",
      "Rather than simulating the entire organisation, Tardigrade typically focuses on a specific function, department or operational area to create meaningful and actionable outcomes.",
      "We'd welcome a conversation to explore whether a targeted exercise would be appropriate.",
    ],
    cta: { label: "Discuss Departmental Simulations", subject: "Departmental Simulations" },
  },
};
